import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [empresas, setEmpresas] = useState([]);
  // ?empresa=ID en la URL (enlaces del correo de resumen, #127) manda sobre
  // la última empresa elegida; si el usuario no la tiene, se ignora.
  const [empresaActiva, setEmpresaActiva] = useState(
    new URLSearchParams(window.location.search).get('empresa') || localStorage.getItem('empresaActivaId') || null
  );
  const [esAdminGlobal, setEsAdminGlobal] = useState(false);
  const [seccionesDeshabilitadas, setSeccionesDeshabilitadas] = useState([]);
  const [cargando, setCargando] = useState(true);

  const cargarSesion = useCallback(async () => {
    try {
      const { data } = await api.get('/auth/yo');
      setUsuario(data.usuario);
      setEmpresas(data.empresas || []);
      setEsAdminGlobal(!!data.esAdminGlobal);
      setSeccionesDeshabilitadas(data.seccionesDeshabilitadas || []);
      const tiene = (id) => data.empresas?.some((e) => String(e.empresa_id) === String(id));
      if (empresaActiva && tiene(empresaActiva)) {
        seleccionarEmpresa(empresaActiva);
      } else if (data.empresas?.length > 0) {
        const guardada = localStorage.getItem('empresaActivaId');
        seleccionarEmpresa(tiene(guardada) ? guardada : data.empresas[0].empresa_id);
      }
    } catch {
      setUsuario(null);
    } finally {
      setCargando(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    cargarSesion();
  }, [cargarSesion]);

  function seleccionarEmpresa(id) {
    localStorage.setItem('empresaActivaId', id);
    setEmpresaActiva(id);
  }

  async function loginConGoogle(credential) {
    const { data } = await api.post('/auth/google', { credential });
    setUsuario(data.usuario);
    setEmpresas(data.empresas || []);
    setEsAdminGlobal(!!data.esAdminGlobal);
    setSeccionesDeshabilitadas(data.seccionesDeshabilitadas || []);
    if (data.empresas?.length > 0) {
      seleccionarEmpresa(data.empresas[0].empresa_id);
    }
    return data;
  }

  async function logout() {
    await api.post('/auth/logout');
    setUsuario(null);
    setEmpresas([]);
    localStorage.removeItem('empresaActivaId');
  }

  const empresaActivaData = empresas.find((e) => String(e.empresa_id) === String(empresaActiva));
  const rolActual = empresaActivaData?.rol;
  const modulosActivos = empresaActivaData?.modulos || {};
  const empresaActivaNombre = empresaActivaData?.empresa_nombre;

  return (
    <AuthContext.Provider
      value={{
        usuario,
        empresas,
        empresaActiva,
        empresaActivaData,
        empresaActivaNombre,
        rolActual,
        esAdminGlobal,
        seccionesDeshabilitadas,
        modulosActivos,
        cargando,
        seleccionarEmpresa,
        loginConGoogle,
        logout,
        refrescarSesion: cargarSesion
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
